import SignDocuments from './SignDocuments';

const Etika = {
  SignDocuments,
};

export default Etika;
